import React, { Component, lazy } from "react";
import { Switch, Route } from "react-router-dom";

import LoginRoute from "services/LoggedInRoute";

const HomeLazy = lazy(() => import("pages/pre-login/home/Home.js"));
const PersonalSignupLazy = lazy(() =>
  import("./personnel-signup/PersonnelSignup")
);
const SignupLazy = lazy(() => import("./personnel-signup/panels/Signup"));
const UnderReviewLazy = lazy(() =>
  import("./personnel-signup/panels/UnderReview")
);
const LoginLazy = lazy(() => import("./login/Login"));
const ProfileSetupLazy = lazy(() => import("./profilesetup/ProfileSetup"));
const ReviewSuccessLazy = lazy(() =>
  import("./personnel-signup/panels/ReviewSuccess")
);
const PrivateBetaLazy = lazy(() =>
  import("./client-signup/private-beta/PrivateBeta")
);

class App extends Component {
  constructor() {
    super();

    this.state = {
      isLoggedIn: false
    };
  }

  render() {
    return (
      <Switch>
        <Route exact path="/" component={() => <HomeLazy />} />
        <Route path="/sign-up" component={() => <SignupLazy />} />
        <Route
          path="/personnel-signup"
          component={() => <PersonalSignupLazy />}
        />
        {/* <LoginRoute path="/personnel-signup" component={PersonalSignupLazy} /> */}
        <Route path="/under-review" component={() => <UnderReviewLazy />} />
        <Route path="/review-success" component={() => <ReviewSuccessLazy />} />
        <Route path="/login" component={() => <LoginLazy />} />
        <Route path="/profilesetup" component={() => <ProfileSetupLazy />} />
        <Route path="/privatebeta" component={() => <PrivateBetaLazy />} />
      </Switch>
    );
  }
}

export default App;
